export const chats = {
  toolApprovals: {
    approvalPrompt: {
      label: 'Waiting for your approval',
      hint: 'The agent paused until you decide.',
      title: '{{agent}} wants to use {{tool}}',
      titleNoAgent: 'The agent wants to use {{tool}}',
      details: 'What it will send',
      approve: 'Approve',
      deny: 'Deny',
      approved: 'Approved',
      denied: 'Denied',
      failed: 'Your answer could not be sent. Try again.',
    },
    question: {
      label: 'Questions from {{agent}}',
      labelNoAgent: 'Questions from the agent',
      failed: 'Your answers could not be sent. Try again.',
      waitingForApproval: 'Your answers go with your decision on the approval above.',
    },
    chat: {
      answerFirst: 'Answer the approval above before sending another message.',
      answerQuestionsFirst: "Answer the agent's questions before sending another message.",
    },
  },
  briefAgentReview: {
    agentCommentIdentity: {
      audience: 'Audience',
    },
    agentCommentsApi: {
      failedToCreateComment: 'Failed to create comment',
    },
    agentMentions: {
      youSuffix: ' (you)',
    },
    briefReviewApi: {
      agentResponseFailed: 'Agent response failed with status {{status}}',
      briefReviewFailed: 'Brief review failed with status {{status}}',
    },
    suggestionBlock: {
      applied: 'Applied',
      apply: 'Apply',
      ignore: 'Ignore',
      ignored: 'Ignored',
      sectionNoLongerExists: 'Section no longer exists',
      suggestedReplacement: 'Suggested replacement',
      working: 'Working…',
    },
    useAgentThreadResponder: {
      agentReplyFailed: 'Agent reply failed',
    },
    useBriefAgentReview: {
      agentReviewFailed: 'Agent review failed',
      postedOfAgentSuggestions: 'Posted {{posted}} of {{total}} agent suggestions',
    },
  },
  chats: {
    agentDeletedNotice: {
      thisToolIsNoLonger:
        'This tool is no longer available. Select another tool to resume chatting.',
    },
    agentTaskConstants: {
      summaryInsights: 'Summary & Insights',
    },
    agentTaskIcon: {
      taskInProgress: 'Task in progress',
    },
    agentTaskRecord: {
      usedTools_one: 'Used {{count}} tool',
      usedTools_other: 'Used {{count}} tools',
    },
    htmlWidget: {
      title: 'Widget',
      noData: 'No data',
      chartError: "Couldn't draw this chart",
      all: 'All',
      fallback: "This widget couldn't load, so here is its data.",
      unreadable: "This widget couldn't be read.",
      fromWidget: 'From a widget',
      fromNamedWidget: 'From the widget "{{title}}"',
    },
    agentTaskStatus: {
      steps_one: '{{count}} step',
      steps_other: '{{count}} steps',
    },
    agentTaskUtils: {
      agent: 'Agent: {{name}}',
      guardrail: 'Guardrail: {{name}}',
      unknownEvent: 'Unknown Event',
    },
    agentThinkingProcess: {
      reasoning: 'Reasoning',
      thinking: 'Thinking...',
    },
    attachmentChipActions: {
      addToChat: 'Add to chat',
      removeFromNextMessage: 'Remove from next message',
    },
    attachmentImageChip: {
      preview: 'Preview {{filename}}',
    },
    chatActions: {
      addFile: 'Add file',
      knowledgeBases: 'Knowledge Bases',
      selectKnowledgeBases: 'Select Knowledge Bases',
      sendMessage: 'Send message',
      uploadingFiles: 'Uploading files…',
    },
    chatAddMenu: {
      add: 'Add',
      addFiles: 'Add files',
      addProjectContext: 'Add project context',
    },
    chatAlert: {
      dismiss: 'Dismiss',
    },
    chatBubble: {
      unavailableAgent: 'Unavailable agent',
      weAreUnableToProcess: 'We are unable to process your request. Please try again.',
    },
    chatDropzone: {
      failedToUploadDroppedFiles: 'Failed to upload dropped files: {{error}}',
    },
    chatGuidelinesSelector: {
      clear: 'Clear',
      guidelines: 'Guidelines',
      noGuidelines: 'No guidelines',
      noResults: 'No results',
      search: 'Search...',
      selectAll: 'Select all',
      youCanPickUpTo: 'You can pick up to {{max}} guidelines at a time. Remove a few to add more.',
    },
    chatGuidelinesSelectorV2: {
      addGuidelines: 'Add guidelines',
      clear: 'Clear',
      clearAllGuidelines: 'Clear all guidelines',
      guidelines: 'Guidelines',
      guidelinesWithCount: 'Guidelines ({{selectedCount}} selected)',
      noGuidelines: 'No guidelines',
      noResults: 'No results',
      search: 'Search...',
      selectAll: 'Select all',
    },
    chatInput: {
      chatInput: 'chat input',
      placeholderAskAnything: 'Ask anything...',
      placeholderConnecting: 'Connecting to agent...',
      placeholderNeedsConfiguration: 'This agent requires configuration before it can be used.',
      placeholderOtherAgentBusy: 'Another agent is generating. Click stop to cancel.',
      placeholderSwitchingAgent: 'Switching agent...',
      placeholderToolUnavailable: 'This tool is no longer available.',
      placeholderUploading: 'Uploading file…',
      sendAnyway: 'Send anyway',
      stopGenerating: 'Stop generating',
      stopGeneratingResponse: 'Stop generating response',
      unsavedEdits: 'Unsaved edits',
      youHaveUnsavedEditsInTheOpenWidget:
        "You have unsaved edits in the open widget. I work from the last saved version, so those edits won't be included. Save them first, or send anyway.",
    },
    chatSuggestions: {
      hide: 'Hide suggestions',
      show: 'Show suggestions',
    },
    chatInputV2: {
      imageModel: 'Image model',
      imageModelNamed: 'Image model: {{model}}',
      noImageModels: 'No image model is enabled in this workspace.',
      effort: {
        label: 'Effort',
        current: 'Effort: {{level}}',
        faster: 'Faster',
        smarter: 'Smarter',
        recommended: 'Recommended',
        useRecommended: 'Use recommended · {{level}}',
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        xhigh: 'Extra high',
        max: 'Max',
      },
      add: 'Add',
      addContextFromProject: 'Add Context From Project',
      addFiles: 'Add files',
      addWithCount: 'Add ({{selectedCount}})',
      aiModel: 'AI model',
      cancel: 'Cancel',
      changeTool: 'Change tool',
      chatInput: 'chat input',
      noTools: 'No tools',
      search: 'Search...',
      searchTools: 'Search tools',
      selectModel: 'Select model',
      sendAnyway: 'Send anyway',
      sendMessage: 'Send message',
      settings: 'Settings',
      stopGenerating: 'Stop generating',
      summarizingEarlierMessages: 'Summarizing earlier messages…',
      thinking: 'Thinking...',
      unsavedEdits: 'Unsaved edits',
      videoNeedsGoogleModel:
        'Video attachments are only supported by Google models. Switch to a Google model to send.',
      videoNeedsGoogleModelNoneEnabled:
        'Video attachments are only supported by Google models, and this agent has none enabled. Remove the video to send.',
      youHaveUnsavedEditsInTheOpenWidget:
        "You have unsaved edits in the open widget. I work from the last saved version, so those edits won't be included. Save them first, or send anyway.",
    },
    chatKnowledgeBaseSelectorV2: {
      addKnowledge: 'Add knowledge bases',
      clear: 'Clear',
      clearAllKnowledgeBases: 'Clear all knowledge bases',
      knowledgeBases: 'Knowledge bases',
      knowledgeBasesWithCount: 'Knowledge bases ({{selectedCount}} selected)',
      noResults: 'No results',
      search: 'Search...',
      searchKnowledgeBases: 'Search knowledge bases',
      selectAll: 'Select all',
    },
    chatMessageFiles: {
      addFileToLibrary: 'Add {{fileName}} to library',
      addToLibrary: 'Add to library',
      addToNextMessage: 'Add {{fileName}} to next message',
      preview: 'Preview {{filename}}',
      removeFromNextMessage: 'Remove {{fileName}} from next message',
    },
    chatMessageProjectContext: {
      addToNextMessage: 'Add {{title}} to next message',
      removeFromNextMessage: 'Remove {{title}} from next message',
    },
    chatPopupNumberInput: {
      done: 'Done',
      enterInteger: 'Enter integer',
      enterNumber: 'Enter number',
      maximum: 'Maximum: {{max}}',
      minimum: 'Minimum: {{min}}',
      pleaseEnterAValidNumber: 'Please enter a valid number',
      range: 'Range: {{min}} - {{max}}',
      valueMustBeAtLeast: 'Value must be at least {{min}}',
      valueMustBeAtMost: 'Value must be at most {{max}}',
    },
    chatsApi: {
      conversionFailed: 'Document conversion failed',
      conversionNoAssetId: 'Conversion completed but no asset ID returned',
      conversionNoJobId: 'No job ID returned from conversion endpoint',
      conversionNoStatus: 'No conversion status returned',
      conversionTimedOut: 'Document conversion timed out',
    },
    chatWidgetToggle: {
      brief: 'Brief',
      chevronRight: 'chevron right',
      createStrategy: 'Create Strategy',
      dataBehindTheAnswer: 'Data behind the answer',
      generatedImage: 'Generated Image',
      generatedVideo: 'Generated Video',
      moreImages: '+{{count}}',
      imageUnavailable: 'Image unavailable',
      interview: 'Interview - {{personaLabel}}',
      reviewThe4Cs: "Review the 4 C's",
      strategicTerritories: 'Strategic Territories',
      version: 'Version {{version}}',
      widgetIcon: 'Widget Icon',
    },
    composerAttachments: {
      remove: 'Remove {{name}}',
    },
    copyChannelMultiSelect: {
      selectChannels: 'Select channels',
    },
    copyGenerationOptions: {
      automaticallyEvaluateAndRefineCopy:
        'Automatically evaluate and refine copy based on audience resonance (score threshold: 80, max 5 iterations). This will take longer to generate.',
      channel: 'Channel',
      channelEmail: 'Email',
      channelPlainText: 'Plain Text',
      copyAgentSettings: 'Copy agent settings',
      describeYourGoals: 'Describe your goals',
      goal: 'Goal',
      responseStyle: 'Response Style',
      responseStyleBalanced: 'Balanced',
      responseStyleFocused: 'Focused',
      responseStyleImaginative: 'Imaginative',
      runQa: 'Run QA',
      variations: 'Variations',
    },
    copyGenerationOptionsLegacy: {
      automaticallyEvaluateAndRefineCopy:
        'Automatically evaluate and refine copy based on audience resonance (score threshold: 80, max 5 iterations). This will take longer to generate.',
      channel: 'Channel',
      describeYourGoals: 'Describe your goals',
      goal: 'Goal',
      model: 'Model',
      qa: 'QA',
      responseStyle: 'Response Style',
      theAiProviderToUse: 'The AI provider to use for copy generation',
      variations: 'Variations',
    },
    errorMetadata: {
      pleaseProvideThisIdentifierTo:
        'Please provide this identifier to the support team if the issue persists:',
      retryWithProvider: 'Retry with {{provider}}',
    },
    fileAttachments: {
      filePreview: 'File preview',
      remove: 'remove',
    },
    guidelinesSelectorTrigger: {
      clearSelection: 'Clear selection',
      guidelines: 'Guidelines',
    },
    imageGenerationOptions: {
      aspectRatio: 'Aspect Ratio',
      customModelId: 'Custom Model ID',
      customWorkflow: 'Custom Workflow',
      imageAgentSettings: 'Image agent settings',
      optionalCustomModelIdentifierFor: 'Optional custom model identifier for Adobe Firefly',
      providerCustom: 'Custom',
      quality: 'Quality',
      qualityAuto: 'Auto',
      qualityHigh: 'High',
      qualityLow: 'Low',
      qualityMax: 'Max',
      qualityMedium: 'Medium',
      qualityXhigh: 'Extra high',
      referenceAccuracy: 'Reference Accuracy',
      referenceAccuracyHigh: 'High',
      referenceAccuracyLow: 'Low',
      resolution: 'Resolution',
      selectACustomWorkflowFor: 'Select a custom workflow for image generation',
      variations: 'Variations',
    },
    imageGenerationOptionsLegacy: {
      accuracy: 'Accuracy',
      aspectRatio: 'Aspect Ratio',
      customModelId: 'Custom Model ID',
      customWorkflow: 'Custom Workflow',
      model: 'Model',
      optionalCustomModelIdentifierFor: 'Optional custom model identifier for Adobe Firefly',
      providerCustom: 'Custom',
      quality: 'Quality',
      referenceAccuracy: 'Reference Accuracy',
      resolution: 'Resolution',
      selectACustomWorkflowFor: 'Select a custom workflow for image generation',
      size: 'Size',
      theAccuracyOfTheReference: 'The accuracy of the reference image',
      theAiProviderToUse: 'The AI provider to use for image generation',
      theAspectRatioOfThe: 'The aspect ratio of the generated image',
      theNumberOfImagesTo: 'The number of images to generate',
      theOutputResolutionTierOf: 'The output resolution tier of the generated image',
      theRenderingQualityOfThe: 'The rendering quality of the generated image',
      theSizeOfTheGenerated: 'The size of the generated image',
      variations: 'Variations',
    },
    internalChatDropzone: {
      dropYourFilesHere: 'Drop your files here!',
      fileDropZone: 'File drop zone',
    },
    intro: {
      loading: 'Loading...',
    },
    languageMultiSelect: {
      noLanguagesFound: 'No languages found',
      searchLanguages: 'Search languages',
      selectLanguages: 'Select languages',
    },
    modelCompatibilityGuard: {
      modelSwitched:
        'AI model switched to {{modelLabel}}. Video attachments are only supported by Google models.',
      videoOnlySupportedByGoogleModels: 'Video attachments are only supported by Google models.',
    },
    modelsDropdown: {
      noModel: 'No model',
    },
    noModelsPanel: {
      aiModels: 'AI Models',
      contactYourOrganizationAdminTo:
        'Contact your organization admin to enable AI models for this agent.',
      noAiModelsAvailable: 'No AI models available',
    },
    omniOptions: {
      aspectRatio: 'Aspect Ratio',
      duration: 'Duration',
      endFrameNeedsStartFrame: 'An end frame needs a start frame',
      resolution: 'Resolution',
    },
    runwayOptions: {
      aspectRatio: 'Aspect Ratio',
      duration: 'Duration',
    },
    runwayOptionsLegacy: {
      aspectRatio: 'Aspect Ratio',
      aspectRatioOfTheGenerated: 'Aspect ratio of the generated video',
      clipDurationInSeconds: 'Clip duration in seconds',
      duration: 'Duration',
    },
    sentinelOptions: {
      model: 'Model',
      theAiProviderToUse: 'The AI provider to use for Sentinel checks',
    },
    startChatSession: {
      agentNotAvailable:
        'This agent is not available in your current workspace. Please contact your administrator.',
      failedToStartChat: 'Failed to start chat. Please try again.',
    },
    strategyAgentOptions: {
      model: 'Model',
      theAiProviderToUse: 'The AI provider to use for strategy generation',
    },
    templatesAgentOptions: {
      autoQaApply: 'Auto-QA & apply',
      campaign: 'Campaign',
      chooseTemplate: 'Choose template',
      noCampaign: 'No campaign',
      noCampaignsAvailable: 'No campaigns available',
      noTemplatesAvailable: 'No templates available',
      preview: 'Preview: {{templateName}}',
      runQaAgainstYourSelected:
        'Run QA against your selected guidelines and apply the fixes automatically in the same pass, every time you generate or edit. Requires at least one selected guideline.',
      selectAtLeastOneGuideline: 'Select at least one guideline for QA to run.',
      template: 'Template',
      templatesAgentSettings: 'Templates agent settings',
    },
    templatesAgentOptionsLegacy: {
      autoQa: 'Auto-QA',
      autoQaNeedsAtLeast:
        'Auto-QA needs at least one selected guideline to run — select one from the guidelines menu.',
      campaign: 'Campaign',
      chooseTemplate: 'Choose template',
      model: 'Model',
      noCampaign: 'No campaign',
      preview: 'Preview: {{templateName}}',
      runQaAgainstYourSelected:
        'Run QA against your selected guidelines and apply the fixes automatically in the same pass, every time you generate or edit. Requires at least one selected guideline.',
      selectACampaignFileFrom:
        'Select a campaign file from the selected knowledge bases to strongly guide the copy (optional)',
      selectAnEmailTemplate: 'Select an email template',
      template: 'Template',
      theAiModelToUse: 'The AI model to use for email generation',
    },
    translationAgentOptions: {
      demographic: 'Demographic',
      describeTargetDemographic: 'Describe target demographic',
      describeToneOfVoice: 'Describe tone of voice',
      language: 'Language',
      responseStyle: 'Response Style',
      toneOfVoice: 'Tone of Voice',
      translateAgentSettings: 'Translate agent settings',
    },
    translationAgentOptionsLegacy: {
      demographic: 'Demographic',
      languages: 'Languages',
      model: 'Model',
      responseStyle: 'Response Style',
      theLlmModelToUse: 'The LLM model to use for translation',
      theTargetDemographicForThe: 'The target demographic for the translation',
      theTargetLanguagesToTranslate: 'The target languages to translate to',
      theToneOfVoiceTo: 'The tone of voice to use for the translation',
      toneOfVoice: 'Tone of Voice',
    },
    useDragEvents: {
      anUnexpectedErrorOccurredWhile: 'An unexpected error occurred while dropping files',
      errorHandlingDroppedFiles: 'Error handling dropped files: {{error}}',
    },
    useFileAttachments: {
      convertingFileType: 'Converting file type. This may take a moment.',
      failedToUploadFile: 'Failed to upload file "{{fileName}}": {{reason}}',
      unknownError: 'Unknown error',
    },
    useFileValidation: {
      rejectedFileUnsupportedFormat: 'Rejected file (unsupported format): {{fileName}}',
      unknownFile: 'Unknown file',
    },
    veoOptions: {
      aspectRatio: 'Aspect Ratio',
      attachedImagesRender8sOnly: 'Attached images render at 8s only',
      duration: 'Duration',
      endFrameRenders8sOnly: 'End frame renders at 8s only',
      n1080pIs169Only: '1080p is 16:9 only',
      n1080pRenders8sOnly: '1080p renders at 8s only',
      resolution: 'Resolution',
    },
    veoOptionsLegacy: {
      aspectRatio: 'Aspect Ratio',
      aspectRatioOfTheGenerated: 'Aspect ratio of the generated video',
      attachedImagesRender8sOnly: 'Attached images render at 8s only',
      clipDurationInSeconds: 'Clip duration in seconds',
      duration: 'Duration',
      endFrameRenders8sOnly: 'End frame renders at 8s only',
      n1080pIs169Only: '1080p is 16:9 only',
      n1080pRenders8sOnly: '1080p renders at 8s only',
      outputResolution: 'Output resolution',
      resolution: 'Resolution',
    },
    videoFrameUploadButton: {
      attach: 'Attach {{label}}',
      clear: 'Clear {{label}}',
      failedToUpload: 'Could not upload {{label}}. Please try again.',
      uploading: 'Uploading {{label}}…',
    },
    videoGenerationOptions: {
      availableOnceTheCurrent: 'Available once the current generation finishes',
      endFrame: 'End frame',
      noVideoModelsAreEnabled: 'No video models are enabled for this agent',
      startFrame: 'Start frame',
      videoAgentSettings: 'Video agent settings',
    },
    videoGenerationOptionsLegacy: {
      availableOnceTheCurrent: 'Available once the current generation finishes',
      endFrame: 'End frame',
      noVideoModelsAreEnabled: 'No video models are enabled for this agent',
      model: 'Model',
      startFrame: 'Start frame',
      theAiProviderToUse: 'The AI provider to use for video generation',
    },
  },
  root: {
    failedToCreateANew: 'Failed to create a new chat. Please try again.',
  },
  sessions: {
    about: {
      description:
        "Revisit any conversation you've had with a tool or agent and carry that thinking forward.",
      keepRecord: 'Keep a running record of how a piece of work came together.',
      returnToWork: 'Return to earlier work and continue without starting over.',
      reusePastRuns: 'Reuse the prompts, outputs, and decisions from past runs.',
      title: 'About sessions',
    },
    errorBoundary: {
      oopsSomethingWentWrong: 'Oops! Something went wrong',
      reloadPage: 'Reload Page',
      weEncounteredAnUnexpectedError:
        'We encountered an unexpected error. Please try refreshing the page.',
    },
    interviewChatHeader: {
      saveToProject: 'Save to project',
      toggleSidePanel: 'Toggle side panel',
    },
    redesignedChatHeader: {
      newChat: 'New Chat',
      sessionName: 'Session name',
    },
    sessionContent: {
      backToPersonas: 'Back to personas',
      personasOverview: 'Personas Overview',
    },
    sessions: 'Sessions',
    sessionsTable: {
      createdAt: 'Created at',
      lastUpdated: 'Last updated',
      loading: 'Loading...',
      noSessionsFound: 'No sessions found',
      title: 'Session',
    },
    sessionsTitleCell: {
      cancel: 'Cancel',
      edit: 'Edit',
      failedToSaveTitle: 'Failed to save title',
      save: 'Save',
    },
    sessionsToolbar: {
      newSession: 'New Session',
      searchSessions: 'Search sessions...',
      searchSessionsLabel: 'Search sessions',
    },
    sessionsViewState: {
      anErrorOccurredAndThe:
        'An error occurred and the data could not be loaded. Please try refreshing the page.',
      clearSearch: 'Clear search',
      dataFailedToLoad: 'Data failed to load',
      navigateToYourDashboardAnd:
        'Navigate to your dashboard and select a task to start a new session. Keep back to this page to instantly return to active sessions.',
      newSession: 'New session',
      noMatchingSessions: 'No matching sessions',
      noSessionsMatchYourCurrent:
        'No sessions match your current search. Please check your search query and try again.',
      noSessionStartedYet: 'No session started yet',
    },
  },
} as const;
